import { useEffect, useState } from 'react'
import AdminLayout from '../../components/AdminLayout'
import { adminGetPedidos, adminMarcarPedidoPagado, adminCancelarPedido } from '../../lib/portalClienteApi'

const ESTADO_PILL = {
  borrador:        { bg: '#f1f5f9', color: '#64748b', label: 'Borrador' },
  pendiente_pago:  { bg: '#fef3c7', color: '#92400e', label: 'Pendiente pago' },
  pagado:          { bg: '#dbeafe', color: '#1e40af', label: 'Pagado' },
  en_armado:       { bg: '#e0e7ff', color: '#3730a3', label: 'En armado' },
  en_ruta:         { bg: '#cffafe', color: '#0e7490', label: 'En ruta' },
  entregado:       { bg: '#dcfce7', color: '#15803d', label: 'Entregado' },
  cancelado:       { bg: '#fee2e2', color: '#991b1b', label: 'Cancelado' },
  rechazado:       { bg: '#fee2e2', color: '#991b1b', label: 'Rechazado' },
}

const TIPO_LABEL = {
  compra_unica:           '📦 Kit único',
  productos_sueltos:      '🛍️ Tienda',
  adicional_suscripcion:  '➕ Extra suscriptor',
  suscripcion:            '🔄 Suscripción',
}

const fmt = (d) => d ? new Date(d + 'T12:00:00').toLocaleDateString('es-UY', { weekday: 'short', day: 'numeric', month: 'short' }) : '—'
const fmtCorto = (d) => d ? new Date(d).toLocaleDateString('es-UY', { day: 'numeric', month: 'short' }) : '—'

export default function AdminPedidos() {
  const [pedidos, setPedidos] = useState([])
  const [loading, setLoading] = useState(true)
  const [filtro, setFiltro] = useState('todos')
  const [accion, setAccion] = useState(null)  // { tipo, pedido }

  async function cargar() {
    setLoading(true)
    const data = await adminGetPedidos({
      estado: filtro === 'todos' ? null : filtro,
      limit: 100,
    })
    setPedidos(data)
    setLoading(false)
  }

  useEffect(() => { cargar() }, [filtro])

  const counts = pedidos.reduce((acc, p) => { acc[p.estado] = (acc[p.estado] || 0) + 1; return acc }, {})

  return (
    <AdminLayout>
      <div className="page">
        <h1>📦 Pedidos one-shot</h1>
        <p className="muted">Pedidos de Kit suelto y La Tienda. Confirmá pagos manuales y movelos de estado.</p>

        {/* Filtros */}
        <div className="ap-filtros">
          {[
            { v: 'todos',           label: 'Todos',          c: pedidos.length },
            { v: 'pendiente_pago',  label: '⏳ Pendiente pago', c: counts.pendiente_pago || 0 },
            { v: 'pagado',          label: '💰 Pagado',      c: counts.pagado || 0 },
            { v: 'en_armado',       label: '📦 En armado',   c: counts.en_armado || 0 },
            { v: 'en_ruta',         label: '🚐 En ruta',     c: counts.en_ruta || 0 },
            { v: 'entregado',       label: '✅ Entregado',   c: counts.entregado || 0 },
            { v: 'cancelado',       label: '❌ Cancelado',   c: counts.cancelado || 0 },
          ].map(o => (
            <button key={o.v}
              className={`ap-filtro ${filtro === o.v ? 'is-active' : ''}`}
              onClick={() => setFiltro(o.v)}>
              {o.label} <em>{o.c}</em>
            </button>
          ))}
        </div>

        {loading && <div className="ap-loading">Cargando…</div>}

        {!loading && pedidos.length === 0 && (
          <div className="ap-empty">
            <div style={{ fontSize: 48 }}>🌱</div>
            <h3>Sin pedidos {filtro !== 'todos' && `en ${filtro}`}</h3>
            <p>Acá van a aparecer los pedidos one-shot que vayan creando los clientes.</p>
          </div>
        )}

        <div className="ap-list">
          {pedidos.map(p => {
            const pill = ESTADO_PILL[p.estado] || ESTADO_PILL.pendiente_pago
            const items = Array.isArray(p.items) ? p.items : []
            const resumen = p.kit_codigo
              ? `Kit ${p.kit_codigo.replace(/_/g, ' ')}`
              : items.length > 0
                ? `${items.reduce((s, it) => s + Number(it.cantidad || 1), 0)} productos`
                : '—'
            return (
              <div key={p.id} className="ap-pedido">
                <div className="ap-pedido-head">
                  <div className="ap-pedido-num">{p.numero_orden}</div>
                  <span className="ap-pill" style={{ background: pill.bg, color: pill.color }}>{pill.label}</span>
                </div>
                <div className="ap-pedido-grid">
                  <div>
                    <div className="ap-tag">Cliente</div>
                    <div className="ap-val">{p.comprador_nombre}</div>
                    {p.comprador_telefono && <div className="ap-sub">📱 {p.comprador_telefono}</div>}
                    {p.comprador_email && <div className="ap-sub">📧 {p.comprador_email}</div>}
                  </div>
                  <div>
                    <div className="ap-tag">Tipo</div>
                    <div className="ap-val">{TIPO_LABEL[p.tipo] || p.tipo}</div>
                    <div className="ap-sub">{resumen}</div>
                  </div>
                  <div>
                    <div className="ap-tag">Entrega</div>
                    <div className="ap-val">{fmt(p.fecha_entrega_programada)}</div>
                    <div className="ap-sub" style={{ textTransform: 'capitalize' }}>
                      {p.entrega_dia_semana} · {p.entrega_ventana === 'tarde' ? 'tarde 14-18' : 'mañana 10-14'}
                    </div>
                    <div className="ap-sub">{p.entrega_direccion}{p.entrega_apto && `, ${p.entrega_apto}`}</div>
                  </div>
                  <div>
                    <div className="ap-tag">Total</div>
                    <div className="ap-val ap-monto">${Number(p.monto_total).toLocaleString('es-UY')}</div>
                    <div className="ap-sub">
                      Sub ${Number(p.monto_subtotal).toLocaleString('es-UY')} + envío ${Number(p.costo_envio).toLocaleString('es-UY')}
                    </div>
                    {p.metodo_pago && <div className="ap-sub">💳 {p.metodo_pago}</div>}
                  </div>
                </div>

                {/* Acciones según estado */}
                <div className="ap-pedido-actions">
                  {p.estado === 'pendiente_pago' && (
                    <>
                      <button className="ap-btn-ok" onClick={() => setAccion({ tipo: 'marcar_pagado', pedido: p })}>
                        ✓ Marcar como pagado
                      </button>
                      <button className="ap-btn-ghost" onClick={() => {
                        const tel = (p.comprador_telefono || '').replace(/\D/g, '')
                        if (!tel) { alert('Sin teléfono'); return }
                        const t598 = tel.startsWith('598') ? tel : '598' + tel.replace(/^0/, '')
                        const msg = `Hola ${p.comprador_nombre.split(' ')[0]}! Te paso los datos para tu pedido ${p.numero_orden} de Limpack ($${Number(p.monto_total).toLocaleString('es-UY')}).`
                        window.open(`https://wa.me/${t598}?text=${encodeURIComponent(msg)}`, '_blank')
                      }}>📲 WhatsApp datos</button>
                    </>
                  )}
                  {p.estado === 'pagado' && (
                    <span className="ap-info">Próximo paso: pasar a "en armado" cuando lo prepares.</span>
                  )}
                  {!['cancelado','entregado','rechazado'].includes(p.estado) && (
                    <button className="ap-btn-link-danger" onClick={() => setAccion({ tipo: 'cancelar', pedido: p })}>
                      Cancelar
                    </button>
                  )}
                </div>

                {p.notas && <div className="ap-notas">📝 {p.notas}</div>}
              </div>
            )
          })}
        </div>

        {accion && (
          <ModalAccion accion={accion} onClose={() => setAccion(null)} onDone={() => { setAccion(null); cargar() }} />
        )}

        <style>{styles}</style>
      </div>
    </AdminLayout>
  )
}

function ModalAccion({ accion, onClose, onDone }) {
  const { tipo, pedido } = accion
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState(null)
  const [referencia, setReferencia] = useState('')
  const [motivo, setMotivo] = useState('')

  async function ok() {
    setBusy(true); setErr(null)
    try {
      if (tipo === 'marcar_pagado') {
        await adminMarcarPedidoPagado(pedido.id, referencia || null)
      } else if (tipo === 'cancelar') {
        if (!confirm(`¿Seguro que querés cancelar ${pedido.numero_orden}?`)) { setBusy(false); return }
        await adminCancelarPedido(pedido.id, motivo || null)
      }
      onDone()
    } catch (e) {
      setErr(e.message)
      setBusy(false)
    }
  }

  return (
    <div className="ap-modal-bg" onClick={onClose}>
      <div className="ap-modal" onClick={e => e.stopPropagation()}>
        <h2>{tipo === 'marcar_pagado' ? `✓ Confirmar pago · ${pedido.numero_orden}` : `❌ Cancelar ${pedido.numero_orden}`}</h2>
        <div className="ap-modal-info">
          <div><strong>Cliente:</strong> {pedido.comprador_nombre}</div>
          <div><strong>Total:</strong> ${Number(pedido.monto_total).toLocaleString('es-UY')}</div>
        </div>
        {tipo === 'marcar_pagado' && (
          <label className="ap-field">
            <b>Referencia (nro transferencia, ticket, etc.)</b>
            <input type="text" value={referencia} onChange={e => setReferencia(e.target.value)} placeholder="ej: TR-2026-0123" />
          </label>
        )}
        {tipo === 'cancelar' && (
          <label className="ap-field">
            <b>Motivo (opcional)</b>
            <textarea rows="2" value={motivo} onChange={e => setMotivo(e.target.value)} placeholder="Cliente pidió cancelar, sin pago, etc." />
          </label>
        )}
        {err && <div className="ap-err">{err}</div>}
        <div className="ap-modal-foot">
          <button className="ap-btn-ghost" onClick={onClose}>Cerrar</button>
          <button className={tipo === 'cancelar' ? 'ap-btn-danger' : 'ap-btn-ok'} onClick={ok} disabled={busy}>
            {busy ? 'Procesando…' : tipo === 'cancelar' ? 'Sí, cancelar' : 'Confirmar pago'}
          </button>
        </div>
      </div>
    </div>
  )
}

const styles = `
.page h1 { margin-top: 12px }
.muted { color: #64748b; font-size: 13px; margin-bottom: 16px }

.ap-filtros { display: flex; gap: 6px; flex-wrap: wrap; margin: 16px 0 24px }
.ap-filtro { padding: 8px 14px; background: #f1f5f9; border: 1.5px solid transparent; border-radius: 999px; font-size: 13px; font-weight: 700; color: #1a3461; cursor: pointer; font-family: inherit; transition: all .15s }
.ap-filtro:hover { background: #e2e8f0 }
.ap-filtro.is-active { background: #1a3461; color: #fff }
.ap-filtro em { font-style: normal; font-size: 11px; opacity: .65; margin-left: 6px; font-weight: 700 }
.ap-filtro.is-active em { color: #00c4d4; opacity: 1 }

.ap-loading, .ap-empty { text-align: center; padding: 60px 20px; color: #64748b }
.ap-empty h3 { color: #1a3461; margin: 12px 0 6px }

.ap-list { display: flex; flex-direction: column; gap: 14px }
.ap-pedido { background: #fff; border: 1px solid #e2e8f0; border-radius: 14px; padding: 18px 20px; box-shadow: 0 2px 8px rgba(26,52,97,.04) }
.ap-pedido-head { display: flex; justify-content: space-between; align-items: center; margin-bottom: 14px }
.ap-pedido-num { font-size: 13px; font-weight: 800; color: #00a8b5; letter-spacing: .08em; font-family: ui-monospace, monospace }
.ap-pill { padding: 4px 12px; border-radius: 999px; font-size: 11px; font-weight: 800; letter-spacing: .04em; text-transform: uppercase }

.ap-pedido-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin-bottom: 14px }
@media (max-width: 800px) { .ap-pedido-grid { grid-template-columns: repeat(2, 1fr) } }
@media (max-width: 500px) { .ap-pedido-grid { grid-template-columns: 1fr } }

.ap-tag { font-size: 10px; font-weight: 800; color: #64748b; text-transform: uppercase; letter-spacing: .08em; margin-bottom: 4px }
.ap-val { font-size: 14px; font-weight: 800; color: #1a3461; line-height: 1.3 }
.ap-sub { font-size: 12px; color: #475569; margin-top: 3px; line-height: 1.4 }
.ap-monto { font-size: 22px; letter-spacing: -.01em }

.ap-pedido-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; padding-top: 12px; border-top: 1px dashed #e2e8f0 }
.ap-btn-ok { background: linear-gradient(135deg, #15803d, #22c55e); color: #fff; border: 0; padding: 10px 18px; border-radius: 999px; font-size: 13px; font-weight: 800; cursor: pointer; font-family: inherit }
.ap-btn-ghost { background: #f1f5f9; color: #1a3461; border: 0; padding: 10px 18px; border-radius: 999px; font-size: 13px; font-weight: 700; cursor: pointer; font-family: inherit }
.ap-btn-link-danger { background: none; border: 0; color: #991b1b; font-size: 12px; font-weight: 600; cursor: pointer; text-decoration: underline; margin-left: auto; padding: 8px 0; font-family: inherit }
.ap-info { font-size: 13px; color: #64748b; font-style: italic }
.ap-notas { margin-top: 12px; padding: 10px 14px; background: #fef3c7; border-radius: 10px; font-size: 13px; color: #92400e }

/* Modal */
.ap-modal-bg { position: fixed; inset: 0; background: rgba(15,31,61,.55); backdrop-filter: blur(4px); z-index: 1000; display: flex; align-items: center; justify-content: center; padding: 16px }
.ap-modal { background: #fff; border-radius: 16px; padding: 24px; max-width: 460px; width: 100%; max-height: 90vh; overflow-y: auto }
.ap-modal h2 { font-size: 18px; font-weight: 900; color: #1a3461; margin: 0 0 14px; letter-spacing: -.01em }
.ap-modal-info { background: #f8fafc; padding: 12px 14px; border-radius: 10px; margin-bottom: 16px; font-size: 13px; line-height: 1.6; color: #1a3461 }
.ap-field { display: block; margin-bottom: 14px }
.ap-field b { display: block; font-size: 11px; font-weight: 800; color: #1a3461; letter-spacing: .08em; text-transform: uppercase; margin-bottom: 6px }
.ap-field input, .ap-field textarea { width: 100%; box-sizing: border-box; padding: 10px 12px; font-size: 14px; border: 1.5px solid #e2e8f0; border-radius: 10px; font-family: inherit }
.ap-err { background: #fef2f2; border: 1px solid #fca5a5; color: #991b1b; padding: 10px 14px; border-radius: 10px; font-size: 13px; margin-top: 10px }
.ap-modal-foot { display: flex; gap: 10px; justify-content: flex-end; margin-top: 18px }
.ap-btn-danger { background: #dc2626; color: #fff; border: 0; padding: 10px 18px; border-radius: 999px; font-size: 13px; font-weight: 800; cursor: pointer; font-family: inherit }
`
